import { createTRPCProxyClient, httpBatchLink, httpLink } from "@trpc/client";
import { type inferRouterInputs, type inferRouterOutputs } from "@trpc/server";

import { type AppRouter } from "@server/api/root";
import superjson from "superjson";

export const getBaseUrl = (): string => {
  if (typeof window !== "undefined") return ""; // browser should use relative url
  if (process.env.VERCEL_URL) return `https://${process.env.VERCEL_URL}`; // SSR should use vercel url
  return `http://localhost:${process.env.PORT ?? 3000}`; // dev SSR should use localhost
};

BigInt.prototype.toJSON = function () {
  return this.toString();
};

export const absoluteUrl = (path: string): string => {
  return getBaseUrl() + path;
};

/** A set of type-safe react-query hooks for your tRPC API. */
export const trpc = createTRPCProxyClient<AppRouter>({
  transformer: {
    ...superjson,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    serialize: (data) => {
      // if its a date object, serialize it as a string
      // if (data instanceof Date) {
      //   return data.toISOString();
      // }
      // if (typeof data === 'bigint') {
      //   return data.toString();
      // }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return data;
    },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    deserialize: (payload) => {
      // if its a date string, deserialize it as a date
      // if (typeof payload === 'string') {
      //   const date = new Date(payload);

      //   if (!isNaN(date.getTime())) {
      //     // return date;
      //     return payload;
      //   }

      //   const number = Number(payload);
      //   try {
      //     const bigint = BigInt(payload);
      //       if (bigint.toString() === payload) {
      //         return bigint;
      //       }
      //   } catch (e) {
      //     return payload;
      //   }

      //   if (!isNaN(number)) {
      //     return number;
      //   }
      // }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return payload;
    },
  },
  links: [
    // Wrap fetch with a 10s timeout for crm.getPage calls to avoid hanging UIs
    // Works for both httpLink and httpBatchLink
    (() => {
      const withTimeoutFetch: typeof fetch = async (input, init) => {
        const url =
          typeof input === "string" ? input : input?.toString?.() || "";
        const needsTimeout = url.includes("crm.getPage");
        if (!needsTimeout)
          return fetch(input as RequestInfo, init as RequestInit);

        const controller = new AbortController();
        const originalSignal = init?.signal;
        const timeoutId = setTimeout(() => controller.abort(), 10_000);
        const cleanup = () => clearTimeout(timeoutId);

        if (originalSignal) {
          if (originalSignal.aborted) controller.abort();
          else
            originalSignal.addEventListener("abort", () => controller.abort(), {
              once: true,
            });
        }

        try {
          const res = await fetch(
            input as RequestInfo,
            {
              ...(init || {}),
              signal: controller.signal,
            } as RequestInit,
          );
          cleanup();
          return res;
        } catch (err) {
          cleanup();
          throw err;
        }
      };

      return ["prod", "staging"].includes(process.env.ENVIRONMENT_HANDLE || "")
        ? httpBatchLink({ url: "/api/trpc", fetch: withTimeoutFetch })
        : httpLink({ url: "/api/trpc", fetch: withTimeoutFetch });
    })(),
  ],
});

/**
 * Inference helper for inputs.
 *
 * @example type HelloInput = RouterInputs['example']['hello']
 */
export type RouterInputs = inferRouterInputs<AppRouter>;

/**
 * Inference helper for outputs.
 *
 * @example type HelloOutput = RouterOutputs['example']['hello']
 */
export type RouterOutputs = inferRouterOutputs<AppRouter>;
